"use strict";
exports.__esModule = true;
exports.OnboardingFlowName = exports.ONBOARDING_PRODUCT_TYPE = void 0;
exports.ONBOARDING_PRODUCT_TYPE = 'flexapp/product';
var OnboardingFlowName;
(function (OnboardingFlowName) {
    OnboardingFlowName["SPLIT_RENT"] = "split_rent";
    OnboardingFlowName["CREDIT_BUILDER"] = "credit_builder";
    OnboardingFlowName["SPLIT_RENT_REJECT_TO_CB"] = "split_rent_reject_to_cb";
})(OnboardingFlowName = exports.OnboardingFlowName || (exports.OnboardingFlowName = {}));
